import { render, staticRenderFns } from "./invReportDI.vue?vue&type=template&id=0f995d4d&scoped=true&"
import script from "./invReportDI.vue?vue&type=script&lang=js&"
export * from "./invReportDI.vue?vue&type=script&lang=js&"
import style0 from "./invReportDI.vue?vue&type=style&index=0&id=0f995d4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f995d4d",
  null
  
)

export default component.exports